var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseMyFrame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.785 4.9698L6.3525 12.3198C4.7775 13.5448 3.5 16.1523 3.5 18.1298V31.0973C3.5 35.1573 6.8075 38.4823 10.8675 38.4823H31.1325C35.1925 38.4823 38.5 35.1573 38.5 31.1148V18.3748C38.5 16.2573 37.0825 13.5448 35.35 12.3373L24.535 4.7598C22.085 3.0448 18.1475 3.1323 15.785 4.9698Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 31.4824V26.2324",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseMyFrame4);
export default __webpack_public_path__ + "static/media/use_my_frame4.f17480eb1daea81d6e6c8bd47c7ef7b5.svg";
export { ForwardRef as ReactComponent };